


















































import { Component, Prop, Vue } from "vue-property-decorator";
import CircularGauge from "./CircularGauge.vue";
import DashCard from "@/components/app/shared/cards/dash-card.vue";
import { ITelemetryCpu } from "@/@types/servers/telemetry";

@Component({
  components: { CircularGauge, DashCard },
})
export default class CpuCard extends Vue {
  @Prop({ type: Object, required: true }) readonly cpu!: ITelemetryCpu;

  get avgUsage(): number {
    if (!this.cpu.perCore || !this.cpu.perCore.length) return 0;
    const sum = this.cpu.perCore.reduce((acc, c) => acc + c.usage, 0);
    return sum / this.cpu.perCore.length;
  }

  get maxCoreUsage(): number {
    if (!this.cpu.perCore || !this.cpu.perCore.length) return 100;
    return Math.max(...this.cpu.perCore.map((c) => c.usage), 1);
  }

  get cpuColor(): string {
    if (this.avgUsage > 80) return "danger";
    if (this.avgUsage > 50) return "warning";
    return "primary";
  }

  coreColorClass(usage: number): string {
    if (usage > 80) return "core-danger";
    if (usage > 50) return "core-warning";
    if (usage > 20) return "core-moderate";
    return "core-low";
  }
}
